module.exports = __webpack_public_path__ + "static/media/DSC_2428-HDR.fb3a960f.jpg";